// extracted by mini-css-extract-plugin
module.exports = {"MainLogo":"MainLogo_MainLogo__3m4Wx"};